export const COVER_PAGE_PADDING = {
  base: "30px",
  md: "50px"
}
